// extracted by mini-css-extract-plugin
module.exports = {"buttonExpand":"ButtonExpand_buttonExpand__PTIxu","open":"ButtonExpand_open___XC1c"};